export enum WellKnownService {
  ALL_AVAILABLE = 'All Available',
  STANDARD = 'Standard',
  EXPEDITED = 'Expedited',
  UNKNOWN = 'Unknown',
}
